import {
  blueYonderLocationSchema,
  WebhookEventType,
} from "@redotech/redo-return-core-common/integrations/returns/blueyonder/blueyonder";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const blueYonderSettings = defineIntegrationSettings({
  fields: {
    enabled: z.boolean(),
    retailerCompanyId: z
      .string()
      .trim()
      .min(1, "Retailer Company ID is required"),
    locations: z.array(blueYonderLocationSchema),
    processingEvent: createEnum(WebhookEventType).nullable(),
    testMode: z.boolean(),
    radiusMiles: z.number().min(1),
  },
  secrets: {},
  connectOnly: {},
  computed: {},
});
